import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Save, Upload, X, Camera, Linkedin, Github, Globe } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
import { useAuth } from '../contexts/AuthContext';
import { Avatar, AvatarFallback, AvatarImage } from '../components/ui/Avatar';
export function EditProfilePage() {
  const navigate = useNavigate();
  const {
    user
  } = useAuth();
  const [formData, setFormData] = useState({
    fullName: user?.nama || '',
    email: user?.email || '',
    phone: user?.telepon || '',
    city: user?.kota || '',
    bio: '',
    currentPosition: '',
    company: '',
    linkedin: '',
    github: '',
    website: '',
    skills: [] as string[]
  });
  const [newSkill, setNewSkill] = useState('');
  const [profileImage, setProfileImage] = useState<File | null>(null);
  const [coverImage, setCoverImage] = useState<File | null>(null);
  const isIndividu = user?.role === 'anggota_individu';
  const isOrganisasi = user?.role === 'anggota_organisasi';
  const isBadanUsaha = user?.role === 'anggota_badan_usaha';
  const isMitra = user?.role === 'mitra_asosiasi';
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Save profile data
    alert('Profil berhasil diperbarui!');
    navigate('/profile');
  };
  const handleImageUpload = (e: React.ChangeEvent<HTMLInputElement>, type: 'profile' | 'cover') => {
    if (e.target.files && e.target.files[0]) {
      if (type === 'profile') {
        setProfileImage(e.target.files[0]);
      } else {
        setCoverImage(e.target.files[0]);
      }
    }
  };
  const addSkill = () => {
    if (newSkill.trim()) {
      setFormData({
        ...formData,
        skills: [...formData.skills, newSkill.trim()]
      });
      setNewSkill('');
    }
  };
  const removeSkill = (index: number) => {
    setFormData({
      ...formData,
      skills: formData.skills.filter((_, i) => i !== index)
    });
  };
  return <div className="min-h-screen bg-white" data-id="element-2442">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-2443">
        {/* Header */}
        <div className="mb-8" data-id="element-2444">
          <Button variant="ghost" onClick={() => navigate('/profile')} className="mb-4" data-id="element-2445">
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-2446" />
            Kembali ke Profil
          </Button>
          <h1 className="text-3xl font-semibold text-neutral-900 mb-2" data-id="element-2447">
            Ubah Profil
          </h1>
          <p className="text-neutral-600" data-id="element-2448">Perbarui informasi profil Anda</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6" data-id="element-2449">
          {/* Cover Image */}
          <Card data-id="element-2450">
            <CardHeader data-id="element-2451">
              <CardTitle data-id="element-2452">Foto Sampul</CardTitle>
            </CardHeader>
            <CardContent data-id="element-2453">
              <div className="relative h-48 bg-gradient-to-r from-neutral-50 to-neutral-100 rounded-lg overflow-hidden border-2 border-dashed border-neutral-300 hover:border-atios-primary transition-colors" data-id="element-2454">
                {coverImage ? <img src={URL.createObjectURL(coverImage)} alt="Cover" className="w-full h-full object-cover" data-id="element-2455" /> : <div className="absolute inset-0 flex items-center justify-center" data-id="element-2456">
                    <div className="text-center" data-id="element-2457">
                      <Camera className="w-12 h-12 text-neutral-400 mx-auto mb-2" data-id="element-2458" />
                      <p className="text-sm text-neutral-600" data-id="element-2459">
                        Klik untuk upload foto sampul
                      </p>
                    </div>
                  </div>}
                <input type="file" accept="image/*" onChange={e => handleImageUpload(e, 'cover')} className="absolute inset-0 opacity-0 cursor-pointer" data-id="element-2460" />
              </div>
            </CardContent>
          </Card>

          {/* Profile Picture */}
          <Card data-id="element-2461">
            <CardHeader data-id="element-2462">
              <CardTitle data-id="element-2463">Foto Profil</CardTitle>
            </CardHeader>
            <CardContent data-id="element-2464">
              <div className="flex items-center gap-6" data-id="element-2465">
                <div className="relative" data-id="element-2466">
                  <Avatar size="xl" className="border-4 border-white shadow-md" data-id="element-2467">
                    {profileImage ? <AvatarImage src={URL.createObjectURL(profileImage)} data-id="element-2468" /> : <AvatarFallback data-id="element-2469">{user?.avatar || 'U'}</AvatarFallback>}
                  </Avatar>
                  <label className="absolute bottom-0 right-0 h-10 w-10 bg-atios-primary rounded-full flex items-center justify-center cursor-pointer hover:bg-atios-secondary transition-colors" data-id="element-2470">
                    <Upload className="w-5 h-5 text-white" data-id="element-2471" />
                    <input type="file" accept="image/*" onChange={e => handleImageUpload(e, 'profile')} className="hidden" data-id="element-2472" />
                  </label>
                </div>
                <div data-id="element-2473">
                  <p className="text-sm text-neutral-600 mb-2" data-id="element-2474">
                    Upload foto profil baru
                  </p>
                  <p className="text-xs text-neutral-500" data-id="element-2475">
                    JPG, PNG atau GIF. Maksimal 5MB.
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Basic Information */}
          <Card data-id="element-2476">
            <CardHeader data-id="element-2477">
              <CardTitle data-id="element-2478">Informasi Dasar</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4" data-id="element-2479">
              <Input label={isIndividu ? 'Nama Lengkap' : 'Nama Organisasi/Perusahaan'} required value={formData.fullName} onChange={e => setFormData({
              ...formData,
              fullName: e.target.value
            })} placeholder={isIndividu ? 'John Doe' : 'PT Teknologi Indonesia'} data-id="element-2480" />
              <Input label="Email" type="email" required value={formData.email} onChange={e => setFormData({
              ...formData,
              email: e.target.value
            })} placeholder="john@example.com" data-id="element-2481" />
              <Input label="Nomor Telepon" type="tel" required value={formData.phone} onChange={e => setFormData({
              ...formData,
              phone: e.target.value
            })} placeholder="+62 812 3456 7890" data-id="element-2482" />
              <Input label="Kota" required value={formData.city} onChange={e => setFormData({
              ...formData,
              city: e.target.value
            })} placeholder="Jakarta" data-id="element-2483" />
            </CardContent>
          </Card>

          {/* Professional Information (Individu only) */}
          {isIndividu && <Card data-id="element-2484">
              <CardHeader data-id="element-2485">
                <CardTitle data-id="element-2486">Informasi Profesional</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4" data-id="element-2487">
                <Input label="Posisi Saat Ini" value={formData.currentPosition} onChange={e => setFormData({
              ...formData,
              currentPosition: e.target.value
            })} placeholder="Senior Backend Developer" data-id="element-2488" />
                <Input label="Perusahaan" value={formData.company} onChange={e => setFormData({
              ...formData,
              company: e.target.value
            })} placeholder="PT Teknologi Indonesia" data-id="element-2489" />
                <div data-id="element-2490">
                  <label className="text-sm font-medium text-neutral-900 block mb-2" data-id="element-2491">
                    Bio
                  </label>
                  <textarea value={formData.bio} onChange={e => setFormData({
                ...formData,
                bio: e.target.value
              })} className="w-full min-h-[120px] rounded-lg border border-neutral-300 bg-white px-4 py-3 text-sm text-neutral-900 placeholder:text-neutral-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-atios-primary" placeholder="Ceritakan tentang diri Anda..." data-id="element-2492" />
                </div>
              </CardContent>
            </Card>}

          {/* Company Information (Organisasi/Badan Usaha) */}
          {(isOrganisasi || isBadanUsaha) && <Card data-id="element-2493">
              <CardHeader data-id="element-2494">
                <CardTitle data-id="element-2495">
                  Informasi {isOrganisasi ? 'Organisasi' : 'Perusahaan'}
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-4" data-id="element-2496">
                <div data-id="element-2497">
                  <label className="text-sm font-medium text-neutral-900 block mb-2" data-id="element-2498">
                    Deskripsi
                  </label>
                  <textarea value={formData.bio} onChange={e => setFormData({
                ...formData,
                bio: e.target.value
              })} className="w-full min-h-[120px] rounded-lg border border-neutral-300 bg-white px-4 py-3 text-sm text-neutral-900 placeholder:text-neutral-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-atios-primary" placeholder="Ceritakan tentang organisasi/perusahaan Anda..." data-id="element-2499" />
                </div>
                <Input label="Website" type="url" value={formData.website} onChange={e => setFormData({
              ...formData,
              website: e.target.value
            })} placeholder="https://www.example.com" data-id="element-2500" />
              </CardContent>
            </Card>}

          {/* Social Links */}
          <Card data-id="element-2501">
            <CardHeader data-id="element-2502">
              <CardTitle data-id="element-2503">Link Sosial Media</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4" data-id="element-2504">
              {isIndividu && <>
                  <div className="relative" data-id="element-2505">
                    <Linkedin className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-neutral-400" data-id="element-2506" />
                    <Input label="LinkedIn" value={formData.linkedin} onChange={e => setFormData({
                  ...formData,
                  linkedin: e.target.value
                })} placeholder="https://linkedin.com/in/johndoe" className="pl-11" data-id="element-2507" />
                  </div>
                  <div className="relative" data-id="element-2508">
                    <Github className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-neutral-400" data-id="element-2509" />
                    <Input label="GitHub" value={formData.github} onChange={e => setFormData({
                  ...formData,
                  github: e.target.value
                })} placeholder="https://github.com/johndoe" className="pl-11" data-id="element-2510" />
                  </div>
                </>}
              <div className="relative" data-id="element-2511">
                <Globe className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-neutral-400" data-id="element-2512" />
                <Input label="Website" value={formData.website} onChange={e => setFormData({
                ...formData,
                website: e.target.value
              })} placeholder="https://www.example.com" className="pl-11" data-id="element-2513" />
              </div>
            </CardContent>
          </Card>

          {/* Skills (Individu only) */}
          {isIndividu && <Card data-id="element-2514">
              <CardHeader data-id="element-2515">
                <CardTitle data-id="element-2516">Keahlian</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4" data-id="element-2517">
                <div className="flex gap-2" data-id="element-2518">
                  <Input value={newSkill} onChange={e => setNewSkill(e.target.value)} placeholder="Tambah keahlian (misal: React, Node.js)" onKeyPress={e => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  addSkill();
                }
              }} data-id="element-2519" />
                  <Button type="button" onClick={addSkill} data-id="element-2520">
                    Tambah
                  </Button>
                </div>
                <div className="flex flex-wrap gap-2" data-id="element-2521">
                  {formData.skills.map((skill, index) => <div key={index} className="flex items-center gap-2 bg-atios-light text-atios-primary px-3 py-1 rounded-full text-sm" data-id="element-2522">
                      <span data-id="element-2523">{skill}</span>
                      <button type="button" onClick={() => removeSkill(index)} className="hover:text-error transition-colors" data-id="element-2524">
                        <X className="w-3 h-3" data-id="element-2525" />
                      </button>
                    </div>)}
                </div>
              </CardContent>
            </Card>}

          {/* Action Buttons */}
          <div className="flex gap-4 pt-6" data-id="element-2526">
            <Button type="button" variant="secondary" onClick={() => navigate('/profile')} className="flex-1" data-id="element-2527">
              Batal
            </Button>
            <Button type="submit" className="flex-1" data-id="element-2528">
              <Save className="w-4 h-4 mr-2" data-id="element-2529" />
              Simpan Perubahan
            </Button>
          </div>
        </form>
      </div>
    </div>;
}